import React, { useCallback, useEffect, useState } from 'react';

import { useGetInvestmentFundsQuery } from 'api/main';
import { texts } from 'utils/languages/fr';

import CapitalAccountManagement from './CapitalAccountManagement';
import { CustomSelect, ListContainer, Loader } from 'components';
import { MenuItem, Typography } from '@mui/material';

const CapitalAccounts = () => {
    const [selectedFund, setSelectedFund] = useState('');
    const handleChangeSelectedFund = useCallback(e => setSelectedFund(+e.target.value), []);

    const {
        data: fundList = [],
        isFetching: fundsLoader,
        isSuccess: fundsFetched,
    } = useGetInvestmentFundsQuery({ visible: 1 });

    useEffect(() => {
        if (fundsFetched) {
            setSelectedFund(prevState => (!prevState ? fundList?.[0]?.id || '' : prevState));
        }
    }, [fundsFetched, fundList]);

    return (
        <ListContainer>
            <Typography variant="h5" align="left" gutterBottom>
                {texts.CAPITAL_ACCOUNT}
            </Typography>
            <Loader loading={fundsLoader || !selectedFund}>
                <CustomSelect fullWidth value={selectedFund} onChange={handleChangeSelectedFund}>
                    {fundList.map(f => (
                        <MenuItem key={f.id} value={f.id}>
                            {f.name}
                        </MenuItem>
                    ))}
                </CustomSelect>
                <CapitalAccountManagement key={+selectedFund} fundId={+selectedFund} />
            </Loader>
        </ListContainer>
    );
};

export default CapitalAccounts;
